__turbopack_context__.v({
  "arrowContainer": "ScrollBasedCarousel-module__5-nLwa__arrowContainer",
  "carousal": "ScrollBasedCarousel-module__5-nLwa__carousal",
  "carousalItems": "ScrollBasedCarousel-module__5-nLwa__carousalItems",
  "carousalParent": "ScrollBasedCarousel-module__5-nLwa__carousalParent",
  "circleBlurBtn": "ScrollBasedCarousel-module__5-nLwa__circleBlurBtn",
  "dMdNone": "ScrollBasedCarousel-module__5-nLwa__dMdNone",
  "element": "ScrollBasedCarousel-module__5-nLwa__element",
  "h3": "ScrollBasedCarousel-module__5-nLwa__h3",
  "pr0": "ScrollBasedCarousel-module__5-nLwa__pr0",
});
